export enum WidgetModalType {
  AddLayer,
  HeatMap,
  ClusterMap,
  CoverageQuota,
  PropertyQuota,
  LoadData,
  SearchByDrawing,
  AdvancedSearch,
  Measurement,
  RegisterElement,
  RegisterEvent,
  MapManagement,
  PrintMap,
  ConvertCoordinate,
  Occurrence,
  Announcements,
  Path,
  Notes,
  Identify,
  Help,
  AvailableCoverage,
  Tools,
}
